import $ from 'jquery';

// Sort the location column based on location only
const tablesaw_sort = () => {
  $('#sort-location').data('tablesaw-sort', function( ascending ) {
    return (a, b) => {
      // split with a regex and remove empty strings, pattern is "1700 Fribourg" => /(\d{4}) (.+)/
      const content_a = a.cell.split( /(\d{4}) (.+)/ ).filter(Boolean),
            content_b = b.cell.split( /(\d{4}) (.+)/ ).filter(Boolean),
            city_a = content_a[1],
            city_b = content_b[1];

      if (ascending) {
        return city_a >= city_b ? 1 : -1;
      } else { // descending
        return city_a < city_b ? 1 : -1;
      }
    };
  });
};

export default tablesaw_sort;
